//
module.exports = function LocalStorage() {
  const storage = window.localStorage;
  if (storage && storage.getItem && storage.setItem && storage.removeItem) {
    return storage;
  }
  throw new Error('LocalStorage is not available');
};
